// Define the colors of the site
const colors = {
    primaryBeige: '#F0A64F',
    primaryBrown: '#2C1A13',
    primaryLightBrown: '#4A311B',
    secondaryRed: '#F1471C',
    secondaryRedBrown: '#A52A2A',
    secondaryBrown: '#1C1306',
    secondaryDarkBrown: '#170E06',
    textBlack: '#040505',
    textWhite: '#FEFFFF',
};

export default colors;
